import ls from '@/config/ls'
import axios from 'axios'
import { message } from 'ant-design-vue';
import Base64 from 'crypto-js/enc-base64'
import HmacSHA256 from 'crypto-js/hmac-sha256'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL + '/api',
    timeout: 30 * 1000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

const err = (error) => {
    let msg = error.response.data.message || '服务异常, 请稍后再试'
    if (error.code === 'ERR_NETWORK') {
        msg = '网络不可用, 请检查后重试'
    }
    if (error.response.status === 401) {
        ls.remove("LOGIN_USER")
    }
    message.error(msg);
    return Promise.reject(error)
}

// request interceptor
instance.interceptors.request.use(config => {
    const bearerToken = ls.get("BEARER_TOKEN")
    if (bearerToken) {
        config.headers['Authorization'] = 'Bearer ' + bearerToken // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    config.headers['X-TJCMedium-Domain'] = window.location.origin

    const signHeaders = getRequestSign(config.method, config.url, config.data)
    for (const key in signHeaders) {
        config.headers[key] = signHeaders[key]
    }

    return config
}, err)

// response interceptor
instance.interceptors.response.use((response) => {
    return response.data
}, err)

function getRequestSign(method, path, body) {
    const millTimestamp = Date.now().toString()
    const nonce = Math.random().toString(36).slice(-8)

    if (path.startsWith('/')) {
        path = path.substring(1)
    }

    path = '/api/' + path

    /**
     * HTTP请求方法\n
     URL\n
     请求时间戳\n
     请求随机串\n
     请求报文主体\n
     */

    const items = [
        method.toUpperCase(),
        path,
        millTimestamp,
        nonce,
        body ? JSON.stringify(body) : ''
    ]

    const sign = Base64.stringify(HmacSHA256(items.join("\n"), millTimestamp.slice(-3)))

    return {
        'X-TJCMedium-Nonce': nonce,
        'X-TJCMedium-Timestamp': millTimestamp,
        'X-TJCMedium-Sign': sign,
    }
}

export {
    instance as http
}
